<script>
import ToastHandler from "../../../invoicing/mixins/ToastHandler.vue";

export default {
    name: "AssetRepartitionEdit",

    props: {
        associate: {
            type: Object,
            required: false
        }
    },

    mixins: [ToastHandler],

    data() {
        return {
            form: {
                name: null,
                shares: 0,
                bare_ownership_shares: 0,
                usufruct_shares: 0
            }
        }
    },


    created() {
        this.initForm()
    },

    methods: {
        initForm() {
            this.form.name = this.associate.associate_type === 'physical'
                ? this.associate.associate_data.civility + ' ' + this.associate.associate_data.firstname + ' ' + this.associate.associate_data.surname
                : this.associate.associate_data.name
            this.form.shares = this.associate.shares
            this.form.bare_ownership_shares = this.associate.bare_ownership_shares
            this.form.usufruct_shares = this.associate.usufruct_shares
        },

        async updateShares() {
            try {
                this.showRecordingToast()
                const response = await axios.put(
                    `/associates/${this.associate.id}/shares`,
                    this.form
                )
                this.showSuccessToast('Parts mises à jour')
                this.$store.commit('legalVM/SET_CLIENT', response.data.data)
                this.$store.commit('legalVM/RESET_STATUS')
            } catch (error) {
                // handle error
                console.log(error)
            }
        },
    }
}
</script>

<template>
    <b-row>
        <b-col sm="6">
            <b-input
                v-model="form.name"
                size="sm"
                class="bg-white"
                disabled/>
        </b-col>
        <b-col sm="2" class="px-1">
            <b-input
                v-model="form.shares"
                size="sm"
                class="text-right number-font"
                @change="updateShares"
            />
        </b-col>
        <b-col sm="2" class="px-1">
            <b-input
                v-model="form.bare_ownership_shares"
                size="sm"
                class="text-right number-font"
                @change="updateShares"
            />
        </b-col>
        <b-col sm="2" class="px-1">
            <b-input
                v-model="form.usufruct_shares"
                size="sm"
                class="text-right number-font"
                @change="updateShares"
            />
        </b-col>
    </b-row>
</template>

<style scoped>

</style>
